<div class="flex">
    <div>
        <sidebar-menu>
            <div class="sidebar-title">
                <hr />
                <div>Mart</div>
            </div>

            <hr class="sidebar-hr" />

            <div class="sidebar-body">
                <ul class="menu" data-menu="list">
                    <li class="menu__item">
                        <a class="menu__link" (click)="clickMenu(menuEnum.Merchants)">Merchants</a>
                    </li>
                </ul>

            </div>
        </sidebar-menu>
    </div>
    <!-- width: calc(100vw - 410px);  -->
    <div class="sidebar-next-right-block">
        <!-- <xpress-topbar style="width: 100vw; display: block; margin-bottom: 20px;"></xpress-topbar> -->

        <mart-merchants *ngIf="activeMenu === menuEnum.Merchants"></mart-merchants>
    </div>
</div>
